import React from "react";
import {
    ContentWrapper,
} from "../Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { MaterialOrderLinkedTitle, MaterialOrderChildLinkedWrapper } from "../../detail/Styled";

interface MaterialOrderLinkProps {
    materialOrderId: string;
    name: string;
    storage: string;
}
export const MaterialOrderLink = ({ materialOrderId, storage, name }: MaterialOrderLinkProps) => {
    return (
        <MaterialOrderChildLinkedWrapper>
            <>
                <MaterialOrderLinkedTitle>
                    Mã đơn hàng vật tư cho {storage}:
                </MaterialOrderLinkedTitle>
                <StyledNavLink to={`/material-orders/${materialOrderId}`}>
                    {name}
                </StyledNavLink>
            </>
        </MaterialOrderChildLinkedWrapper>
    );
};
